// extracted by mini-css-extract-plugin
module.exports = {"previewHolder":"JumbotronDisplay_previewHolder__2Pphr","liveHolder":"JumbotronDisplay_liveHolder__1xQ2O"};